import { useQuery } from '@tanstack/react-query';
import { getDevices } from '@/api/device.api';

export function useDeviceOptions(deviceType: string) {
  return useQuery({
    queryKey: ['devices', deviceType],
    queryFn: () => getDevices(deviceType),
    staleTime: 5 * 60_000,
  });
}
